export default class Seller {
  static async retrieve(axios, id) {
    const response = await axios.post(
      '/graphql/',
      `query {
        sellerRetrieve(id: ${id}) {
          id
          type
          user {
            id
            firstName
            lastName
            email   
            profile {
              image {
                url
              }
            }         
          }
          deals {
            id
            name
            description
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );   

    response.data.data.sellerRetrieve.compressed = {
      user: response.data.data.sellerRetrieve.user,
      deals: response.data.data.sellerRetrieve.deals
    };

    response.data.data.sellerRetrieve.user = response.data.data.sellerRetrieve.user.id;
    response.data.data.sellerRetrieve.deals = response.data.data.sellerRetrieve.deals.map(node => node.id);

    return response.data.data.sellerRetrieve;
  }

  static async all(axios) {
    const response = await axios.post(
      '/graphql/',
      `query{
        sellerList {
          results {
            id
            type
            user {
              id
              firstName
              lastName
              email
              profile {
                image {
                  url
                }
              }            
            }
            deals {
              id
              name
              description
            }                    
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    for(var i = 0; i < response.data.data.sellerList.results.length; i++)
    {
      switch(response.data.data.sellerList.results[i].type) {
        case "E":
           response.data.data.sellerList.results[i].type = "EJECUTIVO";
        break;
        case "V":
           response.data.data.sellerList.results[i].type = "VENDEDOR";
        break;   
        case "G":
           response.data.data.sellerList.results[i].type = "GERENTE DE VENTA";
        break;                      
      }   

      response.data.data.sellerList.results[i].deals = response.data.data.sellerList.results[i].deals.map(deal => deal.name).join(',');   
    }

    return response.data.data.sellerList.results.reverse();
  }

  static async delete(axios, id) {
    const response = await axios.post(
      '/graphql/',
      `mutation{
        deleteSeller(id: ${id}){
          ok
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.deleteSeller.ok;
  }

}